module.exports = __webpack_public_path__ + "6dccb678b954dd8b418cc35ea334841f.pdf";